<template>
    <v-container fluid>
        <v-breadcrumbs :items="breadcrumbsItems" class="pa-0 mb-2" large></v-breadcrumbs>
        <v-card outlined>
            <PayFunctionArea v-bind:isPay="payfunctionMap[functionId]"></PayFunctionArea>
            <v-card-title>
                <v-text-field v-model="searchUserName" :label="$t('student_list.search_student_label')" single-line
                    append-icon="mdi-magnify" 
                    @click:append="searchStudent"
                    clearable @click:clear="clearSearchUserName"
                    hide-details></v-text-field>
                <v-spacer></v-spacer>
            </v-card-title>
            <div class="mx-4">
                <v-divider></v-divider>
            </div>
            <v-subheader>
                {{ formatdatas() }}
                <v-spacer></v-spacer>
                <v-btn
                    class="ma-2 normal-case"
                    outlined
                    text
                    @click="exportData"
                    :disabled="loadingDialog">
                    {{ $t('button.export_data') }}
                </v-btn>
            </v-subheader>

            <v-data-table :headers="headers" :items="datas" :server-items-length="totalRecords" :loading="loading"
                :page.sync="page" :options.sync="studentOptions" :items-per-page="10" hide-default-footer
                :loading-text="$t('general.table.loading')" :no-data-text="$t('general.table.no_data')" :no-results-text="$t('general.table.no_data')"
                disable-sort class="mx-4">

                <template v-slot:item.unread="{ item }">
                    <v-icon v-if="item.unread" color="deep-orange darken-4">
                        mdi-circle-medium </v-icon>
                </template>
                <template v-slot:item.role="{ item }">
                    <v-img :src="item.role" class="role-thumbnail  mx-auto my-2">
                    </v-img>
                </template>
                <template v-slot:item.nameAndAccount="{ item }">
                    <span>{{ item.name }}</span>
                    <br />
                    <span class="font-weight-thin">{{ item.account }}</span>
                </template>
                <template v-slot:item.lastPost="{ item }">
                    <div v-if="item.lastPost">
                        <span>{{ item.lastPost.title }}</span>
                        <br />
                        <span class="red--text text-caption">
                            {{ `#${formatEmotions(item.lastPost.emotions)}` }}
                        </span>
                        <span class="blue--text text-caption">
                            {{ `#${formatBehavior(item.lastPost.behavior)}` }}</span>
                    </div>
                    <span v-else>{{ $t('general.diary.no_data') }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn small class="mr-2 mt-1 normal-case" outlined @click="goToStudentDetail(item.uuid)">
                        <v-icon small class="mr-1"> mdi-eye </v-icon>
                        {{ $t('button.detail') }}
                    </v-btn>
                </template>
                <template v-slot:item.watching="{ item }">
                    <div class="checkbox-container">
                        <v-checkbox v-model="item.watching" @change="addOrRemoveCase(item)"></v-checkbox>
                    </div>
                </template>
            </v-data-table>
            <div class="text-center my-4">
                <v-pagination v-model="page" :length="pageCount" 
                :total-visible="11" circle color="orange accent-2">
                </v-pagination>
            </div>
        </v-card>
        <v-dialog
            v-model="loadingDialog"
            hide-overlay
            persistent
            width="300">
            <v-card color="amber darken-2">
                <v-card-text
                    color="white"
                    class="text-center py-3">
                    {{ $t('record.exporting') }}
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0 my-2"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="noDataDialog"
            persistent
            width="400">
            <v-card class="pa-4">
                <v-subheader>
                    {{ $t('record.no_data') }}
                </v-subheader>
                <v-card-text>
                    {{ $t('record.no_data_description') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text class="normal-case"
                        @click="noDataDialog = false"
                        outlined>
                        {{ $t('record.close') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import fileDownload from "js-file-download";
import { assessmentServices } from '@/services/assessment.js';
import PayFunctionArea from '@/components/console/diary/component/PayFunctionArea.vue'
import {mapState } from "vuex";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getItem } from '@/utils/storageManager';

export default {
    name: 'assessmentResultList',
    components: { PayFunctionArea },
    data() {
        return {
            functionId: 'f3',
            payfunctionMap: JSON.parse(getItem('payfunctionMap')),
            breadcrumbsItems: [],
            headers: [
                {
                    text: this.$t('table.name_account'),
                    value: 'nameAndAccount',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                },
                {
                    text: '問卷名稱',
                    value: 'quizTitle',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                    filterable: false,
                },
                {
                    text: this.$t('table.create_date'),
                    value: 'createDate',
                    sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                    filterable: false,
                },
                {
                    text: this.$t('table.function'), value: 'actions', sortable: false,
                    align: 'center',
                    class: 'grey lighten-4',
                    filterable: false,
                },
            ],
            datas: [
                {
                    name: '',
                    quizTitle: '',
                    studentId: '',
                    action: '',
                    createDate: '3/3/2020 7:29:16 PM',
                },
            ],
            page: 1,
            pageCount: 1,
            totalRecords: 0,
            loading: false,
            studentOptions: {},
            homeWorkId: null,
            searchUserName: null,
            loadingDialog: false,
            noDataDialog: false,
        }
    },
    async created() {
        this.homeWorkId = this.$route.params.id;
        this.breadcrumbsItems.push({
            text: this.$t('index.title'),
            disabled: false,
            href: `/diary`,
        }, {
            text: this.homeworkName,
            disabled: false,
            href: `/diary/homework/${this.homeWorkId}`,
        }, {
            text: this.$t('menu.diary_quiz'),
            disabled: true,
            href: `/diary/${this.homeWorkId}`,
        }
        );
        if (!this.payfunctionMap[this.functionId]) {
            return;
        }
        this.searchUserName = '';

    },
    watch: {
        studentOptions: {
            handler() {
                this.getAssessmentData()
            },
            deep: true,
        },
        homeworkName() {
            this.breadcrumbsItems[1].text = this.homeworkName;
        },
    },
    computed: {
        ...mapState(["homeworkName"]),
    },
    methods: {
        getAssessmentData() {
            if (this.homeWorkId == null)
                return;
            this.loading = true;
            this.getAssessmentList().then(data => {
                this.datas = data.items;
                this.totalRecords = data.total;
                this.pageCount = data.pageCount;
                this.loading = false;
                this.page = data.page;
            })
        },
        searchStudent() {
            if (this.homeWorkId == null)
                return;
            this.studentOptions.page = 1;
            this.getAssessmentData();
        },
        async getAssessmentList() {
            const { page } = this.studentOptions;
            const query = {
                page: page,
                user_name: this.searchUserName,
            };
            const res = await assessmentServices.getAssessmentResultList(this.homeWorkId, query);
            dayjs.extend(utc)
            dayjs.extend(timezone)

            const tz = dayjs.tz.guess()
            const items = res.datas.map(function (d) {
                return {
                    id: d.user_id,
                    quizTitle: d.title,
                    name: d.user_name,
                    account: d.account,
                    createDate: dayjs.utc(d.create_date).tz(tz).format('YYYY-MM-DD HH:mm:ss'),
                    uuid: d.uuid,
                };
            });
            const total = res.total_records;
            const pageCount = res.total_pages;
            return { items, total, pageCount, page }
        },
        async exportData() {
            let payload = {
                homework_id: this.homeworkId,
                start_date: this.dateRangeStart,
                end_date: this.dateRangeEnd,
                order_option: this.orderOption,
                time_desc: this.timeOrderBy == 'desc' ? true : false,
            }

            if (this.targetStudent == 'select') {
                payload['diary_id'] = this.selectDiary;
            }

            let fileName = '';
            let res = null;
            fileName = this.$t('menu.diary_quiz') + '.xlsx'
            res = await assessmentServices.getAssessmentResultDownload(this.homeWorkId);
            
            if (res.status == 200) {
                try {
                    // Clone the response for a second read attempt
                    // Try to read the response as a blob
                    const blobFile = await res.blob();
                    if (blobFile.type !== 'application/json') {
                        fileDownload(blobFile, fileName);
                        this.loadingDialog = false;
                    }
                } catch (error) {
                    console.error('Error processing response:', error);
                    this.loadingDialog = false;
                }
            }
        },
        goToStudentDetail(uuid) {
            // console.log('id:', id)
            this.$router.push({
                name: 'quizResultDetail', params: {
                    id: this.homeWorkId,
                    uuid: uuid
                }
            });
        },
        
        clearSearchUserName() {
            this.searchUserName = '';
            this.getStudentData();
        },
        formatdatas() {
            return this.$t('quiz.records').replace('${num}', this.totalRecords);
        }
    },
}
</script>

<style scoped>
.role-thumbnail {
    width: 50px;
    align-items: center;
}

.checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>